import './ProgressBar.scss';

import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { HOME_JOURNEY, STAGES_HOME_JOURNEY } from '../../constants/journey';
import { commonClass, withPrefix } from '../../helpers';

const ProgressBar = props => {
  const {
    stage,
    labelText = HOME_JOURNEY,
    stages = STAGES_HOME_JOURNEY
  } = props;
  const [step, setStep] = useState(1);
  const className = 'c-ProgressBar';
  const withClass = withPrefix(className);

  const stageBuilder = () => {
    const stepElement = stages.findIndex(item => stage === item);
    setStep(stepElement + 1);
  };

  const renderLine = index => (
    <div className={withClass('__line', index <= step && '__line--active')} />
  );

  const renderIcon = index => {
    const active = index <= step;
    const getActiveSuffix = () => active && '__icon--active';

    return (
      <>
        <div className={commonClass('__hideOnDesktop')}>
          <FontAwesomeIcon
            data-testid={`progress-bar-icon-${step}`}
            icon={active ? faCheckCircle : faCircle}
            className={withClass('__icon', getActiveSuffix())}
          />
        </div>
        <div className={commonClass('__showOnDesktopOnly')}>
          <FontAwesomeIcon
            data-testid={`progress-bar-icon-${step}`}
            icon={active ? faCheckCircle : faCircle}
            className={withClass('__icon', getActiveSuffix())}
            size="2x"
            alt={active ? 'Done' : 'Pending'}
          />
        </div>
      </>
    );
  };

  const renderLabel = (index, label) => (
    <div className={withClass('__label', index <= step && '__label--active')}>
      {label}
    </div>
  );

  useEffect(() => {
    stageBuilder();
  }, [step]);

  return (
    <div className={className}>
      <div className={withClass('__justifyContainer', '__progressContainer')}>
        {stages.map((item, idx) => {
          return (
            <React.Fragment key={idx}>
              {idx > 0 && renderLine(idx + 1)}
              {renderIcon(idx + 1)}
            </React.Fragment>
          );
        })}
      </div>
      <div className={withClass('__justifyContainer', '__labelContainer')}>
        {stages.map((item, idx) => {
          return (
            <React.Fragment key={idx}>
              {renderLabel(idx + 1, labelText[idx])}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  stage: PropTypes.string,
  labelText: PropTypes.array,
  stages: PropTypes.array
};

export default ProgressBar;
